import { render, staticRenderFns } from "./NextEvent.vue?vue&type=template&id=521e72f0&scoped=true&"
import script from "./NextEvent.vue?vue&type=script&lang=js&"
export * from "./NextEvent.vue?vue&type=script&lang=js&"
import style0 from "./NextEvent.vue?vue&type=style&index=0&id=521e72f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521e72f0",
  null
  
)

export default component.exports